export class DashboardColumnRQ {
  public dtVoo: string;
  public sistemaOrigem: string;

  constructor(){
    this.dtVoo = '';
    this.sistemaOrigem = '';
  }
}
